import { DataService } from "@/services/data";
import { ApprenticeshipProductType } from "@/types/apprenticeship/product";
import { PaginatedResponse } from "@/types/common";
import { SFOwnerFieldType } from "@/types/salesforce/fields";
import { RouteObject } from "react-router-dom";

const ApprenticeshipPicklistRoute: RouteObject = {
    path: "picklists",
    children: [
        {
            path: "products",
            loader: async () => {
                const products = (await DataService.client.url(`/apprenticeship/products/`).get().json()) as PaginatedResponse<ApprenticeshipProductType>;
                return products.results;
            }
        },
        {
            path: "agents",
            loader: async () => {
                const agents = (await DataService.client.url(`/apprenticeship/assignations/agents/`).get().json()) as {
                    cap: SFOwnerFieldType[];
                    ce: SFOwnerFieldType[];
                    cs: SFOwnerFieldType[];
                    csm: SFOwnerFieldType[];
                };
                const ids: number[] = [];
                const all_agents: SFOwnerFieldType[] = [];
                agents.cap
                    .concat(agents.ce)
                    .concat(agents.csm)
                    .map(a => {
                        if (ids.indexOf(a.id) == -1) {
                            all_agents.push(a);
                            ids.push(a.id);
                        }
                    });
                return all_agents;
            }
        },
        {
            path: "agents/cap",
            loader: async () => {
                const agents = (await DataService.client.url(`/apprenticeship/assignations/agents/`).get().json()) as {
                    cap: SFOwnerFieldType[];
                    ce: SFOwnerFieldType[];
                    cs: SFOwnerFieldType[];
                    csm: SFOwnerFieldType[];
                };
                return agents.cap;
            }
        },
        {
            path: "agents/ce",
            loader: async () => {
                const agents = (await DataService.client.url(`/apprenticeship/assignations/agents/`).get().json()) as {
                    cap: SFOwnerFieldType[];
                    ce: SFOwnerFieldType[];
                    cs: SFOwnerFieldType[];
                    csm: SFOwnerFieldType[];
                };
                return agents.ce;
            }
        },
        {
            path: "agents/cs",
            loader: async () => {
                const agents = (await DataService.client.url(`/apprenticeship/assignations/agents/`).get().json()) as {
                    cap: SFOwnerFieldType[];
                    ce: SFOwnerFieldType[];
                    cs: SFOwnerFieldType[];
                    csm: SFOwnerFieldType[];
                };
                return agents.cs;
            }
        },
        {
            path: "agents/csm",
            loader: async () => {
                const agents = (await DataService.client.url(`/apprenticeship/assignations/agents/`).get().json()) as {
                    cap: SFOwnerFieldType[];
                    ce: SFOwnerFieldType[];
                    cs: SFOwnerFieldType[];
                    csm: SFOwnerFieldType[];
                };
                return agents.csm;
            }
        }
    ]
};

export default ApprenticeshipPicklistRoute;
